module.exports = __webpack_public_path__ + "static/media/Nobu_hero.3ea606e3.jpg";